import React, { useRef, useState } from 'react';
import Button from '@sats-group/fresh-fitness-ui-lib/react/button';
import Text from '@sats-group/fresh-fitness-ui-lib/react/text';
import File from '@sats-group/icons/24/file';

import type { Attachment as Props } from './attachment.types';

const Attachment: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
  acceptedFileTypes,
  dragAndDropText,
  label,
  name,
  noAttachmentText,
  title,
}) => {
  const [uploadedFile, setUploadedFile] = useState<string>();
  const input = useRef<HTMLInputElement>(null);

  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUploadedFile(e.target.files?.[0]?.name);
  };

  return (
    <div className="attachment">
      {title ? (
        <div className="attachment__title">
          <Text elementName="h2" size={Text.sizes.small}>
            {title}
          </Text>
        </div>
      ) : null}
      <div className="attachment__drop-zone">
        <input
          aria-label={label}
          className="attachment__input"
          type="file"
          accept={acceptedFileTypes}
          id="attachment-input"
          name={name}
          onChange={handleUpload}
          ref={input}
          aria-describedby="attachment-file-status"
        />
        <div className="attachment__icon">
          <File />
        </div>
        <div className="attachment__instruction">
          <Text size={Text.sizes.small}>{dragAndDropText}</Text>
        </div>
        <div aria-hidden="true" className="attachment__button">
          <Button
            tabIndex={-1}
            text={label}
            theme={Button.themes.secondary}
            size={Button.sizes.small}
          />
        </div>
        <div
          aria-live="polite"
          className="attachment__file-status"
          id="attachment-file-status"
        >
          <Text size={Text.sizes.small}>
            {uploadedFile || noAttachmentText}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default Attachment;
